import * as React from 'react'
import { Box, Container, Typography } from '@mui/material'
import { HeaderIcons } from './HeaderIcons'
import PropTypes from 'prop-types'

export function Header({ currentTheme, setCurrentTheme }) {
  const isDark = currentTheme.palette.mode === 'dark'
  return (
    <header>
      <Container sx={{ backgroundColor: 'background.paper', display: 'flex', alignItems: 'center' }}>
        <Box
          component='img'
          src={isDark ? '/logo_dark.png' : '/logo_light.png'}
          alt='Logo'
          sx={{
            height: { xs: '60px', sm: '80px' },
            width: 'auto',
            borderRadius: '30px'
          }}
        />
        <Box
          sx={{
            height: { xs: '20px', sm: '80px' },
            width: '100%',
            ml: { xs: '2', sm: '10' },
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Typography variant='h1' gutterBottom color='customColors.title'>
            Clair de Scène
          </Typography>
        </Box>
        <Box>
          <HeaderIcons currentTheme={currentTheme} setCurrentTheme={setCurrentTheme} />
        </Box>
      </Container>
    </header>
  )
}

Header.propTypes = {
  currentTheme: PropTypes.object.isRequired,
  setCurrentTheme: PropTypes.func.isRequired
}
